import React from 'react';
import { Link } from 'react-router-dom';

const Header = (props) => {
  return (
    <header
      className="masthead"
    >
      <div className="container">
        <br />
        {props.showButton && (
          <Link
            className="btn btn-primary btn-medium text-uppercase js-scroll-trigger"
            to={props.link}
          >
            {props.buttonText}
          </Link>
        )}
      </div>
    </header>
  );
}


export default Header;